/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Email_SuppressionsInputs */

const en_nav_email_suppressions = /** @type {(inputs: Nav_Email_SuppressionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suppressed addresses`)
};

/**
* | output |
* | --- |
* | "Suppressed addresses" |
*
* @param {Nav_Email_SuppressionsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const nav_email_suppressions = /** @type {((inputs?: Nav_Email_SuppressionsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Email_SuppressionsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_nav_email_suppressions(inputs)
});